import { errorHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Get, Param, Post, Query, Req, Res, UploadedFiles, UseInterceptors } from '@nestjs/common';
import { ApiConsumes, ApiHeader, ApiParam, ApiQuery, ApiTags } from '@nestjs/swagger';
import { BloodGroupService } from './blood-group.service';
import { AllBGroupResponseModel, BGroupResponseModel } from './blood-response-module';
import { BloodGroupDTO, DeleteBloodGroupDTO, GroupSearchDto } from './dto/blood-group.dto';
@ApiTags('BloodGroup')
@Controller('bloodgroup')
export class BloodGroupController {
    constructor (
        private BgService: BloodGroupService,
    ){}

    /**
     * create text/url post 
     * @param queryParam which returns api version
     * @param postDto which passes details to be saved
     * @param request which returns headers 
     * @returns postResponse which returns the updated data along with status (true/false), errortype, intlcode, internal message which provides message the calling function.   
     */
    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/createBloodGroup') 
    @ApiQuery({name:'apiVersion'})   
    async createBloodGroup(@Query() queryParam,@Body() bgDto:BloodGroupDTO,@Req() request:Request): Promise<BGroupResponseModel> {
        try {
            return await this.BgService.createBloodGroup(queryParam,bgDto,request);
        } catch (error) {
            return errorHandler(BGroupResponseModel, error);
        }
    }

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/updateBloodGroup') 
    @ApiQuery({name:'apiVersion'})   
    async updateBloodGroup(@Query() queryParam,@Body() bgDto:BloodGroupDTO,@Req() request:Request): Promise<BGroupResponseModel> {
        try {
            return await this.BgService.updateBloodGroup(queryParam, bgDto, request);
        } catch (error) {
            return errorHandler(BGroupResponseModel, error);
        }
    }

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Get('/getBloodGroups')
    @ApiQuery({name:'apiVersion'})
    async getBloodGroups(@Query() queryParams, @Req() request:Request):Promise<AllBGroupResponseModel> {
        try {           
            return await this.BgService.getBloodGroups(queryParams,request);
        } catch (error) {
            return errorHandler(AllBGroupResponseModel, error);
        }
    }
    
    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/deleteBloodGroup')
    @ApiQuery({name:'apiVersion'})
    async deleteBloodGroup(@Query() queryParams, @Body() delDto: DeleteBloodGroupDTO, @Req() request: Request): Promise<BGroupResponseModel> {
        try {   
            return await this.BgService.deleteBloodGroup(queryParams,delDto, request);
        } catch (error) {
            return errorHandler(BGroupResponseModel, error);
        }
    }  
    
    @Post('/searchBloodGroup')
    @ApiQuery({name:'apiVersion'})
    public async searchBloodGroup(@Query() queryParams, @Body() searchDto:GroupSearchDto, @Req() request:Request): Promise<AllBGroupResponseModel> {
        try {
            return await this.BgService.searchBloodGroup(queryParams,searchDto.searchTerm,request);
        } catch (error) {
            return errorHandler(AllBGroupResponseModel, error);
        }
    }
}
